<template>
  <index
    :additional-route-params="additionalRouteParams"
    :breadcrumbs="breadcrumbs"
    admin-view="admin-component-knowledgecheck"
    header-text="Component Knowledge Check"
    response-view="client-component-knowledgecheck-response-show"
  />
</template>

<script>

import index from './index'
import { mapState } from 'vuex'

export default {
  components:{
    index
  },
  data(){
    return {
      breadcrumbs: [
        { text: 'Modules',to: { name: 'client-modules' } },
        { text: 'Components', to: { name: 'client-components' } },
        { text: 'Knowledge Check', active: true }
      ]
    }
  },
  computed:{
    ...mapState('components', {
      component: 'current'
    }),
    additionalRouteParams(){
      return {
        component: this.component.id
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/component-index.vue